import constants from "@blackink/core/categoryConstants";
import { POPULAR_TAGS } from "@blackink/core/tagLists";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { Box, Button, Typography, styled } from "@mui/material";
import React, { useState } from "react";
import { useLocation } from "react-router-dom";

const ImageBackdrop = styled("span")(({ theme }) => ({
  position: "absolute",
  left: 0,
  right: 0,
  bottom: 0,
  height: "20px",
  // Add a gradient to the image for better readability
  backgroundImage:
    "linear-gradient(to top, rgba(255,255,255,1), rgba(255,255,255,0.5))",
  transition: theme.transitions.create("opacity"),
}));

const LongDescription = ({ descriptions }) => {
  const location = useLocation();
  const [expanded, setExpanded] = useState(false);

  const toggleExpanded = () => {
    setExpanded(!expanded);
  };

  const autoLink = (text) => {
    console.debug('text',text);
    try {
      // Autolink categories urls in the description
      let re = new RegExp(
        `(?<!<a[^>]*>)\\b(${Object.values(constants.CATEGORY_DESC)
          .map((cat) => cat.name.toLowerCase())
          .filter((cat) => !location.pathname.includes(cat))
          .join()})\\b(?!</a>)`,
        "gi",
      );
      // Use the category key as the link
      let newText = text.replace(re, (match) => {
        const key = constants.CATEGORIES.find(
          (k) => constants.CATEGORY_DESC[k].name.toLowerCase() === match.toLowerCase(),
        );
        return `<a href="/styles/${key}">${match}</a>`;
      });
      const ideasMerged = [
        ...new Set([...constants.BODY_PARTS, ...constants.GENDERS, ...POPULAR_TAGS]),
      ]
        .filter((tag) => !location.pathname.includes("/" + tag.toLowerCase()))
        .join("|");

      re = new RegExp(`(?<!<a[^>]*>)\\b(${ideasMerged})\\b(?!</a>)`, "gi");
      newText = newText.replace(re, (match) => {
        return `<a href="/tattoo-ideas/${match.toLowerCase()}">${match}</a>`;
      });
      return { __html: newText };
    } catch (e) {
      return { __html: text };
    }
  };

  return (
    <Box>
      <Box
        sx={{
          maxHeight: expanded ? "none" : "105px",
          overflow: "hidden",
          position: "relative",
        }}
      >
        {!expanded && <ImageBackdrop />}
        {descriptions.map((desc: string, i: number) => (
          <React.Fragment key={i}>
            <Typography
              variant="body1"
              component="p"
              sx={{ mt: 1 }}
              dangerouslySetInnerHTML={autoLink(formatDescription(desc, 1))}
            />
            <Typography
              variant="body1"
              component="p"
              sx={{ mt: 1 }}
              dangerouslySetInnerHTML={autoLink(formatDescription(desc, 2))}
            />
          </React.Fragment>
        ))}
      </Box>
      {descriptions.length > 0 && descriptions[0].length > 100 && (
        <Box sx={{ textAlign: "right" }}>
          <Button
            onClick={toggleExpanded}
            size="small"
            color="primary"
            sx={{ zIndex: 10 }}
          >
            {expanded ? <ExpandLess /> : <ExpandMore />}
            {expanded ? "Read Less" : "Read More"}
          </Button>
        </Box>
      )}
    </Box>
  );
};

const formatDescription = (description: string, chunk: number) => {
  const descriptionAsArray = description.split(".");
  const descriptionArrayChunk = descriptionAsArray.length / 2;
  let formattedDescription = "";
  if (chunk === 1) {
    formattedDescription = descriptionAsArray
      .filter((data: string, k: number) => k <= descriptionArrayChunk && data)
      .join(",");
  } else {
    formattedDescription = descriptionAsArray
      .filter((data: string, k: number) => k > descriptionArrayChunk && data)
      .join(",");
  }
  formattedDescription +=
    formattedDescription[formattedDescription.length - 1] !== undefined ? "." : "";
  return formattedDescription;
};

export default LongDescription;
